/**
 * Legacy product add-on display helpers (payment-status / packageDetails).
 */

function num (value) {
  var n = Number(value)
  return isNaN(n) ? 0 : n
}

/** Package supports per-block product add-ons (Standard, Professional, etc.). */
export function isProductAddonApplicable (packageDetails) {
  if (!packageDetails || typeof packageDetails !== 'object') return false
  var fee = num(
    packageDetails.addonSubscriptionFeeCents != null
      ? packageDetails.addonSubscriptionFeeCents
      : packageDetails.addon_subscription_fee_cents
  )
  var block = num(
    packageDetails.addonSubscriptionProducts != null
      ? packageDetails.addonSubscriptionProducts
      : packageDetails.addon_subscription_products
  )
  return fee > 0 && block > 0
}

/**
 * Billable add-on units — prefer Stripe-synced count (including 0).
 * Falls back to suggested only when no synced count is available.
 */
export function resolveProductAddonCount (packageDetails, addonCount) {
  if (addonCount != null && addonCount !== '') return Math.max(0, num(addonCount))
  if (packageDetails) {
    var fromPkg =
      packageDetails.addonCount != null ? packageDetails.addonCount : packageDetails.addon_count
    if (fromPkg != null && fromPkg !== '') return Math.max(0, num(fromPkg))
    var suggested =
      packageDetails.suggestedAddonCount != null
        ? packageDetails.suggestedAddonCount
        : packageDetails.suggested_addon_count
    if (suggested != null && suggested !== '') return Math.max(0, num(suggested))
  }
  return 0
}

export function productAddonMonthlyFeeCents (packageDetails, addonCount) {
  if (!isProductAddonApplicable(packageDetails)) return 0
  var count = resolveProductAddonCount(packageDetails, addonCount)
  var fee = num(packageDetails.addonSubscriptionFeeCents || packageDetails.addon_subscription_fee_cents)
  return count * fee
}

export function totalSubscriptionFeeCents (packageDetails, addonCount) {
  if (!packageDetails) return 0
  var base = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents)
  return base + productAddonMonthlyFeeCents(packageDetails, addonCount)
}

function formatDollars (cents, fixed) {
  var n = num(cents) / 100
  if (fixed) return '$' + n.toFixed(fixed)
  if (Math.floor(n) === n) return '$' + n
  return '$' + n.toFixed(2)
}

/** Account overview / plan card subline (e.g. "$39/month (+2 add-ons)"). */
export function formatAccountPlanPricingSubline (packageDetails, addonCount) {
  if (!packageDetails) return ''
  var baseCents = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents)
  var count = resolveProductAddonCount(packageDetails, addonCount)

  var packageKey = String(
    packageDetails.packageKey != null ? packageDetails.packageKey : packageDetails.package_key || ''
  ).toUpperCase()
  var period = packageKey === 'FLAT_YEARLY' || String(packageDetails.tier || '') === 'flat_yearly' ? '/year' : '/month'

  if (!isProductAddonApplicable(packageDetails) || count <= 0) {
    return formatDollars(baseCents) + period
  }

  var totalCents = totalSubscriptionFeeCents(packageDetails, count)
  return (
    formatDollars(totalCents) +
    '/month (+' +
    count +
    ' add-on' +
    (count === 1 ? '' : 's') +
    ')'
  )
}

/** Legacy billing settings plan description. */
export function formatLegacyBillingPricingLine (packageDetails, addonCount) {
  if (!packageDetails) return ''
  var baseCents = num(packageDetails.baseSubscriptionFeeCents || packageDetails.base_subscription_fee_cents)
  var count = resolveProductAddonCount(packageDetails, addonCount)

  if (!isProductAddonApplicable(packageDetails)) {
    return formatDollars(baseCents, 0) + '/mo base · see invoices for ASIN usage'
  }

  if (count <= 0) {
    return formatDollars(baseCents, 0) + '/mo base · add-ons apply above included listings'
  }

  var addonFeeCents = num(packageDetails.addonSubscriptionFeeCents || packageDetails.addon_subscription_fee_cents)
  var block = num(packageDetails.addonSubscriptionProducts || packageDetails.addon_subscription_products)
  var totalCents = totalSubscriptionFeeCents(packageDetails, count)
  var perBlock = formatDollars(addonFeeCents, 0)
  return (
    formatDollars(totalCents, 0) +
    '/mo total (' +
    formatDollars(baseCents, 0) +
    ' base + ' +
    count +
    ' add-on' +
    (count === 1 ? '' : 's') +
    ' @ ' +
    perBlock +
    '/mo per ' +
    block +
    ' listings)'
  )
}



// WEBPACK FOOTER //
// ./src/utils/productAddonBilling.js